import type { EpisodeManifest, NewsDevelopmentNotice } from "./stage-api";

// Presentation shape checks only. The server owns evidence and publication approval.
export function validReportingInstant(value: unknown): value is string {
  if (typeof value !== "string" || value !== value.trim()) return false;
  const date = /^(\d{4})-(\d{2})-(\d{2})T/.exec(value);
  if (!date || !/(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return false;
  const day = new Date(Date.UTC(Number(date[1]), Number(date[2]) - 1, Number(date[3])));
  return day.toISOString().slice(0, 10) === date[0].slice(0, 10) &&
    Number.isFinite(Date.parse(value)) && Date.parse(value) > 0;
}

export function developmentNoticeFor(episode: EpisodeManifest): NewsDevelopmentNotice | null {
  const notice = episode.newsCoverage?.developmentNotice;
  if ((episode.slot !== "morning" && episode.slot !== "afternoon") ||
      !notice || typeof notice.text !== "string" ||
      notice.text.length === 0 || notice.text.length > 220 || notice.text !== notice.text.trim() ||
      /[\x00-\x1f\x7f\[\]<>*_`]|\s{2}|https?:\/\/|www\./i.test(notice.text) ||
      notice.text.split(/\s+/u).length > 20 || !validReportingInstant(notice.asOfUtc)) return null;
  return notice;
}

export function developmentNoticeAsOf(notice: NewsDevelopmentNotice): string {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Denver", month: "short", day: "numeric", year: "numeric",
    hour: "numeric", minute: "2-digit", timeZoneName: "short",
  }).format(new Date(notice.asOfUtc));
}

export function noticeAwareStoryCard(episode: EpisodeManifest, card = episode.storyCard): EpisodeManifest["storyCard"] {
  return card && developmentNoticeFor(episode) ? { ...card, headline: episode.title } : card;
}
